/**
 * Shared unit display formatter.
 *
 * Rules:
 *  1. "square foot" / "ft^2" → "sq ft"
 *  2. "cubic yard" / "yd^3" → "cu yd"
 *  3. First letter always lowercase (e.g., "Ton" → "ton", "Gallon" → "gallon")
 *  4. Already-abbreviated units (lf, sf, ea, hr) pass through unchanged
 */

const UNIT_ALIASES: Record<string, string> = {
  'square foot': 'sq ft',
  'ft^2': 'sq ft',
  'cubic yard': 'cu yd',
  'yd^3': 'cu yd',
}

export function fmtUnit(unit: string | undefined | null): string {
  if (!unit) return '—'

  // Check alias map (case-insensitive)
  const lower = unit.toLowerCase().trim()
  const alias = UNIT_ALIASES[lower]
  if (alias) return alias

  // Lowercase first letter, keep the rest as-is
  const trimmed = unit.trim()
  if (trimmed.length === 0) return '—'
  return trimmed[0].toLowerCase() + trimmed.slice(1)
}
